import './App.css';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Home from './components/Home/Home';
import Contact from './components/Contact/Contact';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Footer from './components/Footer';
import Instructions from './components/Instructions/Instructions';
import EditorsDash from './components/Dashboard/EditorsDash';
import Dashboard from './components/Dashboard/Dashboard';
import LoginDash from './components/Dashboard/LoginDash';
import { useEffect, useRef, useState } from 'react';
import Editorial from './components/Editorial/Editorial';
import AnnouncementsDash from './components/Dashboard/AnnouncementsDash';
import AllAnnouncements from './components/AllAnnouncements/AllAnnouncements';
import { useLocation } from 'react-router-dom';
import SingleAnnouncement from './components/AllAnnouncements/SingleAnnouncement';
import IssuesDash from './components/Dashboard/IssuesDash';
import ArticlesDash from './components/Dashboard/ArticlesDash';
import AllArticles from './components/AllArticles/AllArticles';
import SingleArticle from './components/AllArticles/SingleArticle';
import Archive from './components/Archive/Archive';
import ReviewersDash from './components/Dashboard/ReviewersDash';
import Reviewers from './components/Reviewers/Reviewers';

function App() {

  const [type, setType] = useState('');
  const [message, setMessage] = useState('');

  // Create a ref to access Navbar's function
  const navbarRef = useRef();

  const showMessage = (type, message) => {
    setType(type);
    setMessage(message);
    triggerNavbarMessage();
  };

  // Trigger the function inside Navbar from here
  const triggerNavbarMessage = () => {
    if (navbarRef.current) {
      navbarRef.current.triggerMessage();
    }
  };

  useEffect(() => {
    if (message) {
      triggerNavbarMessage();
    }
  }, [message]);

  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  }


  return (
    <Router>
      <ScrollToTop />
      <Header ref={navbarRef} message={message} type={type}/>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home title="Annals of Nursing | International Scientific Journal"/>} />
        <Route path="/instructions" element={<Instructions title="Annals of Nursing - Instructions"/>} />
        <Route path="/editorial" element={<Editorial title="Annals of Nursing - Editorial Board"/>} />
        <Route path="/reviewers" element={<Reviewers title="Annals of Nursing - Reviewers"/>} />
        <Route path="/contact" element={<Contact title="Annals of Nursing - Contact Us"/>} />
        <Route path="/dashboard" element={<Dashboard showMessage={showMessage} title="Annals of Nursing - Dashboard"/>} />
        <Route path="/dashboard/login" element={<LoginDash showMessage={showMessage} title="Annals of Nursing - Dashboard"/>} />
        <Route path="/dashboard/editors" element={<EditorsDash showMessage={showMessage} title_page="Annals of Nursing - Dashboard"/>} />
        <Route path="/dashboard/reviewers" element={<ReviewersDash showMessage={showMessage} title_page="Annals of Nursing - Dashboard"/>} />
        <Route path="/dashboard/announcements" element={<AnnouncementsDash showMessage={showMessage} page_title="Annals of Nursing - Dashboard"/>} />
        <Route path="/dashboard/issues" element={<IssuesDash showMessage={showMessage} page_title="Annals of Nursing - Dashboard"/>} />
        <Route path="/dashboard/articles" element={<ArticlesDash showMessage={showMessage} page_title="Annals of Nursing - Dashboard"/>} />
        <Route path="/announcements" element={<AllAnnouncements page_title="Annals of Nursing - Announcements"/>} />
        <Route path="/announcement/:id/:slug" element={<SingleAnnouncement page_title="Annals of Nursing - Announcement"/>} />
        <Route path="/articles" element={<AllArticles page_title="Annals of Nursing - Articles"/>} />
        <Route path="/article/:id/:slug" element={<SingleArticle page_title="Annals of Nursing - Article"/>} />
        <Route path="/archive" element={<Archive page_title="Annals of Nursing - Archive"/>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
